import { z } from 'zod'

export const appointmentActionOutcomeSchema = z
  .object({
    appointmentId: z.string().trim().min(1).max(32),
    outcome: z.enum([
      'confirmed',
      'cancelled',
      'already-confirmed',
      'already-cancelled',
      'reconciliation-required',
    ]),
  })
  .strict()

export type AppointmentActionOutcome = z.infer<
  typeof appointmentActionOutcomeSchema
>
export type AppointmentAction = 'confirm' | 'cancel'
